export interface Image {
  id?: string;
  imageId: string | null;
  src: string;
  blob?: Blob;
}

export type SearchProduct = {
  product_id: string;
  title: string;
  handle: string;
};

export type TargetItem = {
  _id: string;
  product_id: string;
  handle: string;
  title: string;
};

export enum ActionType {
  reply,
  edit,
  approve,
  delete,
}

export interface IResponse<T> {
  data: T;
}

export enum SortBy {
  titleAsc = 'title-asc',
  titleDesc = 'title-desc',
  createdAsc = 'created-asc',
  createdDesc = 'created-desc',
}

export enum CommentStatus {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
}

export enum CommentType {
  review = 'review',
  question = 'question',
  replyReview = 'replyReview',
  replyQuestion = 'replyQuestion',
}

export enum ShapeType {
  star_1 = 'star_1',
  star_2 = 'star_2',
  heart_1 = 'heart_1',
  heart_2 = 'heart_2',
}

export enum QuestionShowType {
  list = 'list',
  tab = 'tab',
}
